import React from 'react';
import {Button} from '@bosch/react-frok';
import {PageIndicator} from '../../PageIndicator/PageIndicator';
import {t} from 'i18next';
import {ItemsFooterWrapper} from './ItemsFooter.style';

export interface ItemsFooterProps {
    readonly page: number;
    readonly pageCount: number;
    onPageChange: (newPage: number) => void;
}

/**
 * @name ItemsFooter
 * @description
 * Component for the footer of the item visualisation
 */
export const ItemsFooter: React.VFC<ItemsFooterProps> = (props) => (
    <ItemsFooterWrapper>
        <div>
            <Button
                icon='arrow-left'
                disabled={props.page === 1}
                label={t('FOOTER_COMPONENT_PREVIOUS_PAGE')}
                mode='secondary'
                onClick={() => {
                    props.onPageChange(props.page - 1);
                }}
            />
        </div>
        <PageIndicator pages={props.pageCount} selected={props.page} onPageSelect={props.onPageChange}/>
        <div>
            <Button
                icon='arrow-right'
                disabled={props.page >= props.pageCount}
                label={t('FOOTER_COMPONENT_NEXT_PAGE')}
                mode='secondary'
                onClick={() => props.onPageChange(props.page + 1)}
            />
        </div>
    </ItemsFooterWrapper>
);
